/**
 * Every TanStack Query key in the app, in one place. Keys are hierarchical,
 * so invalidating `trip(id)` also refreshes `activities(id)`, and `users()`
 * refreshes every `user(email)`.
 */
export const queryKeys = {
  users: () => ["user"] as const,
  user: (email: string | null) => ["user", email] as const,
  trip: (tripId: string | undefined) => ["trip", tripId] as const,
  activities: (tripId: string | undefined) => ["trip", tripId, "activities"] as const,
  inviteLinks: (tripId: string) => ["invite-links", tripId] as const,
  inviteLink: (token: string) => ["invite-link", token] as const,
};
